<template>
  <div class="setup">
    <input type="file" ref="fileInput" id="fileInput" @change="uploadModel"/>
    <Recipient ref="recipients"
               v-for="(recipient, index) in recipients"
               :key="index"
               v-model="recipients[index]"/>
    <vue-button @click="addRecipient">Add Recipient</vue-button>
    <vue-button @click="remRecipient">Remove Recipient</vue-button>
    <vue-button @click="downloadModel">Save to Disk</vue-button>
    <vue-button @click="openFileDialog">Load from Disk</vue-button>
    <vue-button @click="generateSESRequest">Generate SES Request</vue-button>
  </div>
</template>

<script>
  import _ from 'lodash-es'
  import { saveAs } from 'file-saver'
  import Recipient from '../components/Recipient.vue'

  const defaultRecipient = () => ({
    email: '',
    persons: [{ name: 'Person 1' }],
  })

  export default {
    name: 'recipientSetup',
    data() {
      return {
        recipients: [{ ...defaultRecipient() }],
      }
    },
    computed: {
      totalPersons() {
        return this.recipients.map(recipient => recipient.persons.length)
          .reduce((a, b) => a + b, 0)
      },
    },
    methods: {
      addRecipient() {
        this.recipients.push({ ...defaultRecipient() })
        this.setJustLastExpanded()
      },
      remRecipient() {
        this.recipients.pop()
        this.setJustLastExpanded()
      },
      downloadModel() {
        const fileDownload = new Blob([JSON.stringify(this.recipients)], { type: 'application/json;charset=utf-8' })
        saveAs(fileDownload, 'recipients.json')
      },
      generateSESRequest() {
        const destinations = this.recipients.filter(r => r.email)
          .map(r => ({
            Destination: {
              ToAddresses: [r.email],
            },
            ReplacementTemplateData: JSON.stringify({
              link: `https://kitandmariette.com/invitation?payload=${btoa(r.reference)}`,
            }),
          }))
        const requestFull = JSON.stringify({
          Source: 'Kit and Mariette <us@kitandmariette.com>',
          Template: 'Invitation',
          ConfigurationSetName: 'Invitations',
          Destinations: destinations,
          DefaultTemplateData: JSON.stringify({ link: 'https://kitandmariette.com/' }),
        })
        const fileDownload = new Blob([requestFull], { type: 'application/json;charset=utf-8' })
        saveAs(fileDownload, 'ses_request.json')
      },
      openFileDialog() {
        this.$refs.fileInput.click()
      },
      async uploadModel() {
        const body = await this.$refs.fileInput.files[0].text()
        console.log(body)
        this.setFromJSONString(body)
        this.$refs.recipients.forEach(recipient => recipient.collapse())
      },
      setFromJSONString(json) {
        this.recipients = JSON.parse(json)
      },
      setJustLastExpanded() {
        this.$nextTick(() => {
          this.$refs.recipients.forEach(recipient => recipient.collapse())
          this.$refs.recipients.slice(-1)
            .forEach(recipient => recipient.expand())
        })
      },
    },
    watch: {
      recipients: {
        handler: _.debounce((recipients) => {
          const stringified = JSON.stringify(recipients)
          localStorage.setItem('setup-model', stringified)
        }, 400),
        deep: true,
      },
    },
    created() {
      if (localStorage.getItem('setup-model')) {
        this.setFromJSONString(localStorage.getItem('setup-model'))
        this.setJustLastExpanded()
      }
    },
    mounted() {
    },
    components: {
      Recipient,
    },
  }
</script>

<style lang="scss" scoped>
  #fileInput {
    visibility: hidden;
  }

  .setup {
    position: absolute;
    left: 0;
    width: 100vw;
  }

</style>
